import { __extends } from "tslib";
import { GetSegmentsRequest, GetSegmentsResponse } from "../models/models_1";
import { deserializeAws_restJson1GetSegmentsCommand, serializeAws_restJson1GetSegmentsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Retrieves information about the configuration, dimension, and other settings for all the segments that are associated with an application.</p>
 */
var GetSegmentsCommand = /** @class */ (function (_super) {
    __extends(GetSegmentsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetSegmentsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetSegmentsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetSegmentsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetSegmentsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetSegmentsResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetSegmentsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetSegmentsCommand(input, context);
    };
    GetSegmentsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetSegmentsCommand(output, context);
    };
    return GetSegmentsCommand;
}($Command));
export { GetSegmentsCommand };
//# sourceMappingURL=GetSegmentsCommand.js.map